
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    quote: "The team transformed our outdated website into a modern, high-converting platform. Our online inquiries increased by 240% in the first three months. Their attention to detail and understanding of our business was exceptional.",
    author: "Sarah Mitchell",
    role: "CEO",
    company: "TechFlow Solutions",
    image: "https://public.readdy.ai/ai/img_res/f6e7d63828a4077c28c3588d3d76710c.jpg",
    rating: 5
  },
  {
    id: 2,
    quote: "Working with this team was a game-changer for our e-commerce business. They didn't just build a website; they created a seamless shopping experience that our customers love. Sales are up 180% and cart abandonment is down significantly.",
    author: "Marcus Chen",
    role: "Founder",
    company: "Urban Threads",
    image: "https://readdy.ai/api/search-image?query=young%20asian%20male%20entrepreneur%20smiling%20in%20casual%20business%20attire%20bright%20modern%20workspace%20simple%20clean%20background%20professional%20portrait&width=400&height=400&seq=webdesign-testimonial-2&orientation=squarish",
    rating: 5
  },
  {
    id: 3,
    quote: "From the initial consultation to launch, the process was smooth and collaborative. They took time to understand our brand and delivered a website that perfectly captures our essence. The mobile experience is flawless.",
    author: "Emily Rodriguez",
    role: "Marketing Director",
    company: "Wellness Haven",
    image: "https://readdy.ai/api/search-image?query=professional%20latina%20woman%20in%20elegant%20business%20outfit%20warm%20smile%20natural%20office%20setting%20simple%20background%20corporate%20headshot%20photography&width=400&height=400&seq=webdesign-testimonial-3&orientation=squarish",
    rating: 5
  },
  {
    id: 4,
    quote: "The redesign exceeded all expectations. Our bounce rate dropped by 60% and time on site doubled. The SEO optimization they implemented has us ranking on page one for our key terms. Best investment we've made.",
    author: "David Thompson",
    role: "Operations Manager",
    company: "Green Energy Co",
    image: "https://readdy.ai/api/search-image?query=mature%20professional%20businessman%20with%20glasses%20confident%20expression%20modern%20office%20background%20clean%20simple%20setting%20corporate%20portrait%20style&width=400&height=400&seq=webdesign-testimonial-4&orientation=squarish",
    rating: 5
  },
  {
    id: 5,
    quote: "They delivered a stunning portfolio website that showcases our work beautifully. The animations are subtle yet impactful, and the loading speed is incredible. We've received countless compliments from clients.",
    author: "Jessica Park",
    role: "Creative Director",
    company: "Studio Noir",
    image: "https://readdy.ai/api/search-image?query=stylish%20young%20female%20creative%20director%20artistic%20professional%20attire%20contemporary%20studio%20setting%20simple%20clean%20background%20modern%20portrait&width=400&height=400&seq=webdesign-testimonial-5&orientation=squarish",
    rating: 5
  },
  {
    id: 6,
    quote: "Outstanding service from start to finish. They were patient with our feedback, responsive to changes, and delivered ahead of schedule. The website is fast, secure, and exactly what we envisioned.",
    author: "Robert Kim",
    role: "Business Owner",
    company: "Artisan Coffee Co",
    image: "https://readdy.ai/api/search-image?query=friendly%20asian%20male%20business%20owner%20casual%20professional%20look%20warm%20inviting%20smile%20simple%20neutral%20background%20natural%20portrait%20photography&width=400&height=400&seq=webdesign-testimonial-6&orientation=squarish",
    rating: 5
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-teal-100 to-orange-100 rounded-full mb-4">
            <i className="ri-chat-quote-line text-2xl text-teal-600"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here&apos;s what businesses say about working with us.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {/* Main Testimonial Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              {/* Image */}
              <div className="flex-shrink-0">
                <div className="w-32 h-32 rounded-full overflow-hidden ring-4 ring-teal-100">
                  <img
                    src={currentTestimonial.image}
                    alt={currentTestimonial.author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                {/* Stars */}
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl text-orange-500"></i>
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-lg text-gray-700 mb-6 leading-relaxed">
                  &quot;{currentTestimonial.quote}&quot;
                </blockquote>

                {/* Author Info */}
                <div>
                  <p className="text-lg font-bold text-gray-900">
                    {currentTestimonial.author}
                  </p>
                  <p className="text-sm text-gray-600">
                    {currentTestimonial.role} at {currentTestimonial.company}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-teal-600 hover:shadow-xl transition-all cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-teal-600 hover:shadow-xl transition-all cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'bg-gradient-to-r from-teal-500 to-orange-500 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-1">500+</div>
            <div className="text-sm text-gray-600">Websites Delivered</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-1">98%</div>
            <div className="text-sm text-gray-600">Client Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-1">4.9/5</div>
            <div className="text-sm text-gray-600">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-gray-900 mb-1">85%</div>
            <div className="text-sm text-gray-600">Repeat Clients</div>
          </div>
        </div>
      </div>
    </section>
  );
}
